var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.pageLoading, tip: "操作中..." } },
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "app-container" },
            [
              _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "vxe-button",
                          {
                            attrs: { status: "primary" },
                            on: { click: _vm.addFun },
                          },
                          [_vm._v("新增")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("span", { staticStyle: { "margin-right": "8px" } }, [
                          _vm._v("触达渠道编码:"),
                        ]),
                        _c("a-input", {
                          staticStyle: {
                            width: "200px",
                            "margin-right": "1rem",
                          },
                          attrs: {
                            placeholder: "触达渠道编码",
                            "allow-clear": "",
                          },
                          model: {
                            value: _vm.queryCondition.channelCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryCondition, "channelCode", $$v)
                            },
                            expression: "queryCondition.channelCode",
                          },
                        }),
                        _c("span", { staticStyle: { "margin-right": "8px" } }, [
                          _vm._v("触达渠道:"),
                        ]),
                        _c(
                          "a-select",
                          {
                            staticStyle: {
                              width: "200px",
                              "margin-right": "1rem",
                            },
                            attrs: {
                              placeholder: "触达渠道名称",
                              "allow-clear": "",
                              "show-search": "",
                              "filter-option": _vm.filterChannelOption,
                            },
                            model: {
                              value: _vm.queryCondition.channelName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "channelName", $$v)
                              },
                              expression: "queryCondition.channelName",
                            },
                          },
                          _vm._l(_vm.allChannels, function (channel) {
                            return _c(
                              "a-select-option",
                              {
                                key: channel.id,
                                attrs: { value: channel.channelName },
                              },
                              [_vm._v(" " + _vm._s(channel.channelName) + " ")]
                            )
                          }),
                          1
                        ),
                        _c(
                          "vxe-button",
                          {
                            attrs: { status: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.queryByPage(1)
                              },
                            },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "vxe-button",
                          {
                            staticClass: "filter-search-item",
                            on: { click: _vm.resetForm },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c(
                "vxe-table",
                {
                  ref: "xTable",
                  staticClass: "mytable-scrollbar",
                  attrs: {
                    loading: _vm.listLoading,
                    align: _vm.allAlign,
                    "max-height":
                      _vm.$store.state.app.height - 130 < 500
                        ? 500
                        : _vm.$store.state.app.height - 130,
                    border: "",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "column-config": { resizable: true },
                    stripe: "",
                    round: "",
                    "scroll-y": { enabled: false },
                    "row-config": { isHover: true },
                    data: _vm.tableData,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: {
                      type: "seq",
                      title: "序号",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "channelCode",
                      title: "触达渠道编码",
                      "min-width": "150",
                      align: "center",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "channelName",
                      title: "触达渠道名称",
                      "min-width": "150",
                      align: "center",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "sourceNames",
                      title: "关联线索来源",
                      "min-width": "250",
                      align: "center",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "createDate",
                      title: "创建时间",
                      "min-width": "180",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    row.createDate,
                                    "yyyy-MM-dd HH:mm:ss"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "200",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "operate" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  "current-page": _vm.pagination.current,
                  "page-size": _vm.pagination.size,
                  total: _vm.pagination.total,
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.changePage },
              }),
            ],
            1
          ),
          _c(
            "a-modal",
            {
              attrs: { title: _vm.dialogTitle, width: "600px" },
              on: { ok: _vm.submitForm, cancel: _vm.cancelForm },
              model: {
                value: _vm.dialogVisible,
                callback: function ($$v) {
                  _vm.dialogVisible = $$v
                },
                expression: "dialogVisible",
              },
            },
            [
              _c(
                "a-form-model",
                {
                  ref: "channelForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.formRules,
                    "label-col": { span: 6 },
                    "wrapper-col": { span: 16 },
                  },
                },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "触达渠道编码", prop: "channelCode" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入触达渠道编码",
                          maxLength: 50,
                          disabled: !!_vm.formData.id,
                        },
                        model: {
                          value: _vm.formData.channelCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "channelCode", $$v)
                          },
                          expression: "formData.channelCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "触达渠道名称", prop: "channelName" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入触达渠道名称",
                          maxLength: 100,
                        },
                        model: {
                          value: _vm.formData.channelName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "channelName", $$v)
                          },
                          expression: "formData.channelName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "关联线索来源", prop: "sourceIdList" } },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            mode: "multiple",
                            placeholder: "请选择线索来源",
                          },
                          model: {
                            value: _vm.formData.sourceIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sourceIdList", $$v)
                            },
                            expression: "formData.sourceIdList",
                          },
                        },
                        _vm._l(_vm.sourceOptions, function (item) {
                          return _c(
                            "a-select-option",
                            { key: item.codeId, attrs: { value: item.codeId } },
                            [_vm._v(" " + _vm._s(item.codeName) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("a-textarea", {
                        attrs: {
                          placeholder: "请输入备注",
                          rows: 4,
                          maxLength: 500,
                        },
                        model: {
                          value: _vm.formData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "remark", $$v)
                          },
                          expression: "formData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "vxe-button",
                    { attrs: { size: "small" }, on: { click: _vm.cancelForm } },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      attrs: { size: "small", status: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }